import { SET_CURRENT_PERIOD, SET_COMPARE_PERIOD, SET_FILTER_PERIOD } from "../constants/actionTypes";

export const setCurrentPeriod = (currentPeriod) => {
  return {
    type: SET_CURRENT_PERIOD,
    currentPeriod,
  };
};

export const setComparePeriod = (comparePeriod) => {
  return {
    type: SET_COMPARE_PERIOD,
    comparePeriod,
  };
};

export const setFilterPeriod = (filterPeriod) => {
  return {
    type: SET_FILTER_PERIOD,
    filterPeriod,
  };
};
